// https://usehooks.com/useLocalStorage/
import { useState } from 'react';
import { isBrowser } from '../utils/environment';

export function useLocalStorage(key, initialValue) {
    const isServer = !isBrowser();
    const [ready, setReady] = useState(false);
    const [error, setError] = useState(null);
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        if (isServer) {
            return initialValue;
        }

        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);

            setReady(true);

            return item ? JSON.parse(item) : initialValue;
        } catch (e) {
            // eslint-disable-next-line
            console.log(e);

            setReady(true);
            setError(e);

            return initialValue;
        }
    });

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value) => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);

            // Save to local storage
            if (!isServer) {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            }
        } catch (e) {
            // eslint-disable-next-line
            console.log(e);
        }
    };

    return [storedValue, setValue, ready, error];
}
